import React, { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SAME_ROUTE_CLICK_EVENT } from '@constants/common/miscellaneous';

/**
 * Displays Links that has only Icons but connects to React Router.
 *
 * @param props - details from component and environment API props
 * @returns {*} HTML content.
 */

const RouterSymbol = (props) => {
    const {
        details: {
            name,
            className,
            textClassname,
            linkClassName,
            additionalProperties,
            symbols,
            path,
            urlReplacements,
            text,
            showUnreadMessage
        },
        environment: {
            reduxUnreadMessageCount
        },
        index,
        replacements
    } = props;

    const location = useLocation();
    const url = urlReplacements ? path.processReplacements(urlReplacements) : path.processReplacements(replacements);

    const handleClick = (e) => {
        // Check if we're already on the target route
        if (location.pathname !== url) return;
        e.preventDefault();
        // Dispatch a custom event for same-route clicks
        const event = new CustomEvent(SAME_ROUTE_CLICK_EVENT, { 
            detail: { 
                route: url, 
                name: name 
            } 
        });
        window.dispatchEvent(event);
    };

    return (
        <Fragment>
            {
                <li className={className} data-automation-id={name}>
                    <Fragment>
                        {
                            additionalProperties ?
                                <Link
                                    to={url}
                                    className={linkClassName}
                                    target= {additionalProperties.target}
                                    rel= {additionalProperties.rel}
                                    id={name + '_' + index}
                                    text={text}
                                    data-automation-id={name + '_' + index}
                                    onClick={handleClick}
                                >
                                    <span key={`${name + '_' + index}`} className={textClassname}>
                                        <FormattedMessage id={text} />
                                    </span>
                                    {
                                        symbols.map(symbol => (
                                            <FontAwesomeIcon key={symbol} className={symbol} icon={symbol} />))}
                                    {
                                        showUnreadMessage && reduxUnreadMessageCount > 0 ? <span key="unread-badge-visible" className="unreadRecords">{reduxUnreadMessageCount}</span> :
                                            showUnreadMessage && reduxUnreadMessageCount <= 0 ? <span key="unread-badge-hidden" className="unreadRecords hide"></span> : null
                                    }
                                </Link>

                                :

                                <Link
                                    to={url}
                                    className={linkClassName}
                                    id={name + '_' + index}
                                    data-automation-id={name + '_' + index}
                                    onClick={handleClick}
                                >
                                    <span key={`${name + '_' + index}`} className={textClassname}>
                                        <FormattedMessage id={text} />
                                    </span>
                                    {
                                        symbols.map(symbol => (
                                            <FontAwesomeIcon key={symbol} className={symbol} icon={symbol} />))}
                                    {
                                        showUnreadMessage && reduxUnreadMessageCount > 0 ? <span key="unread-badge-visible" className="unreadRecords">{reduxUnreadMessageCount}</span> :
                                            showUnreadMessage && reduxUnreadMessageCount <= 0 ? <span key="unread-badge-hidden" className="unreadRecords hide"></span> : null
                                    }
                                </Link>
                        }
                    </Fragment>
                </li>
            }
        </Fragment>
    );
};

export default RouterSymbol;